import { ImageModel } from '../../model/media-library/image.model';
import { IImageResponse } from '../../interface/media-library/image-response.interface';

export const createImageModelFromData = (file: IImageResponse) => {
  const image = new ImageModel();
  image.id = file.id;
  image.name = file.name;
  image.location = file.location;
  image.largeLocation = file.largeLocation;
  image.imageUrl = file.imageUrl;
  image.smallLocation = file.smallLocation;
  image.mediumLocation = file.mediumLocation;
  image.thumbnailLocation = file.thumbnailLocation;
  image.iconLocation = file.iconLocation;
  image.dimensions = file.dimensions;
  image.size = file.size;
  image.created = file.createdDate;
  return image;
};
